import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, ArrowCounterClockwise } from "@phosphor-icons/react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-lg bg-card border border-border rounded-sm p-10 md:p-14 text-center"
      >
        <ArrowCounterClockwise size={44} weight="duotone" className="text-accent mx-auto" />
        <h1 className="font-serif text-3xl md:text-4xl text-primary tracking-tight mt-6" data-testid="payment-cancel-heading">
          No charge was made
        </h1>
        <p className="mt-4 text-foreground/70 leading-relaxed">
          You left the checkout before paying — nothing was charged and nothing is owed.
          The offers will be waiting whenever you're ready.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/"
            data-testid="payment-cancel-retry-link"
            onClick={(e) => { e.preventDefault(); window.location.href = "/#pricing"; }}
            className="bg-primary text-primary-foreground px-8 py-3.5 rounded-full font-semibold text-sm hover:bg-accent transition-colors duration-300"
          >
            Return to pricing
          </Link>
          <Link
            to="/"
            data-testid="payment-cancel-home-link"
            className="flex items-center gap-2 text-sm font-semibold text-muted-foreground hover:text-primary transition-colors duration-300"
          >
            <ArrowLeft size={15} weight="bold" /> Home
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
